import {initExportDateRange, validateExportDateRange} from "./export_date_range";

// Wires the shared date range inputs inside a modals/form-modal export form
function initExportModalDateRange() {
  const dateRangeElement = document.querySelector('[data-export-date-range]');
  if (!dateRangeElement) {
    return;
  }

  const form = dateRangeElement.closest('form');
  const validationAlertElement = form.querySelector('.export-validation-alert');

  initExportDateRange(dateRangeElement);

  form.addEventListener('submit', (evt => {
    const errorMessage = validateExportDateRange(dateRangeElement);

    if(errorMessage) {
      evt.preventDefault();
      validationAlertElement.textContent = errorMessage;
      validationAlertElement.classList.remove('hidden');
      // Undo the "Submitting..." swap the modal's submit button makes on click
      form.querySelector('.export-modal-actions')?.classList.remove('hidden');
      form.querySelector('.export-modal-processing')?.classList.add('hidden');
    }
    else {
      validationAlertElement.classList.add('hidden');
    }
  }));
}

export function initView() {
  let viewIdentifier = document.body.dataset.viewIdentifier;
  viewInitializers[viewIdentifier]?.();
}

const viewInitializers = {
  "activity-export-new": () => {
    const dateRangeElement = document.querySelector('[data-export-date-range]');

    initExportDateRange(dateRangeElement);

    document.getElementById('activity-form').addEventListener('submit', (evt => {
      const validationAlertElement = document.getElementById('validation-alert');
      const eventTypes = document.querySelectorAll('input[name="event-types"]:checked');
      const errorMessage = eventTypes.length > 0
        ? validateExportDateRange(dateRangeElement)
        : 'Activity type is required!';

      if(errorMessage) {
        evt.preventDefault();
        validationAlertElement.textContent = errorMessage;
        validationAlertElement.classList.remove('hidden');
      }
      else {
        validationAlertElement.classList.add('hidden');
      }
    }));
  },
  "leadgroup-share-show": initExportModalDateRange,
  "leadgroup-show": () => {
    initExportModalDateRange();

    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if(params.get('export')) {
      params.delete('export');

      let updatedUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, null, updatedUrl);
    }
  },
  "faq-show": () => {


    let params = new URLSearchParams(document.location.search),
        vid = params ? params.get("autoplay") : null;
    console.log("faq loading");
    console.log(window.wistaEnabled);
    if(vid && window.wistiaEnabled) {

      const parser = new DOMParser();
      const doc = parser.parseFromString('<div class="load-container video-loader"><div class="loader"><span class="ldr-blk"></span><span class="ldr-blk an_delay"></span><span class="ldr-blk an_delay"></span><span class="ldr-blk"></span></div></div>', 'text/html');
      const loadNode = doc.body.firstElementChild;

      document.body.prepend(loadNode);

      //console.log(vid);
      window._wq = window._wq || [];
      _wq.push({ id: vid, onReady: function(video) {
        video._attrs.autoplay = false;
        video._attrs.popoverAnimateThumbnail = false;
        video._attrs.silentAutoPlay = false;
        video.bind("popovershow", function() {
          setTimeout(() => {loadNode.remove()}, 500);
        });
        video.popover.show();
        window.vid = video;
      }});
    }
  }
}
